import React from "react";
import FormItem from "../../../../components/UI/FormItem";
import {
  EMAIL_REGEX,
  NON_SPECIAL_CHAR_REGEX,
} from "../../../../helpers/constants";
import { useSelector } from "react-redux";

const FormFields = ({ isEdit, stateAdminData, userTitle }) => {
  const {
    newStateAdminError,
  } = useSelector((state) => state.stateAdminManagement);

  const userTitleLower = userTitle?.toLowerCase();
  return<div>
     <FormItem
              name="name"
              rules={[
                {
                  required: !isEdit,
                  message: `Please fill the ${userTitleLower} name to proceed!`,
                },
                {
                  pattern: NON_SPECIAL_CHAR_REGEX, // restrict names with only special characters
                  message: "Please enter a valid name!",
                },
              ]}
              placeholderText={`${userTitle} Name`}
              disabled={isEdit}
              defaultValue={stateAdminData?.name}
              formErrors={newStateAdminError}
            />
            <FormItem
              name="email"
              rules={[
                {
                  required: !isEdit,
                  message: "Please fill the email to proceed!",
                },
                {
                  pattern: EMAIL_REGEX,
                  message: `Invalid Email ID`,
                },
              ]}
              placeholderText={"Email ID"}
              defaultValue={stateAdminData?.email}
              disabled={isEdit}
              formErrors={newStateAdminError}
           />
  </div>
}

export default FormFields;
